import { useEffect, useState } from "react";
import useForm from "../../../hooks/useForm";
import { Button, Col, Form, Modal, notification, Row, Select } from "antd";
import TagsInput from "./AddEmailsComponent";
import "../../../theme/FaltantesRemitentes.css";
// import usePost from "../../../hooks/usePost";
import useRequest from "../../../hooks/useRequest";
import { UseAdmin } from "../../../hooks";
import UsePermissions from "../../../hooks/usePermissions";

const MARCAS = [
  {
    value: 1,
    label: "Burger King",
  },
  {
    value: 2,
    label: "Chili's",
  },
  {
    value: 3,
    label: "El Portón",
  },
  {
    value: 4,
    label: "Italianni's",
  },
  {
    value: 5,
    label: "P.F.Chang's",
  },
  {
    value: 6,
    label: "Starbucks",
  },
  {
    value: 7,
    label: "The Cheesecake Factory",
  },
  {
    value: 8,
    label: "Vips",
  },
  {
    value: 9,
    label: "Dommino's Pizza",
  },
];

export default function RemitenteAddForm(props) {
  const {
    showModal,
    setShowModal,
    setIsEdit,
    selectedItem,
    isEdit,
    refetch,
    isBranchAlreadyCreated,
  } = props;

  const { brandfiMarcaId } = UseAdmin();

  const { hasAllBrandsViewChild1, hasAllPermissionsChild1 } = UsePermissions();

  const [marcas, setMarcas] = useState([]);

  useEffect(() => {
    if (!hasAllBrandsViewChild1 && !hasAllPermissionsChild1) {
      const filteredMarcas = MARCAS.filter((marca) => marca.value === parseInt(brandfiMarcaId));
      setMarcas(filteredMarcas);
    } else {
      setMarcas(MARCAS);
    }
  }, [hasAllBrandsViewChild1, hasAllPermissionsChild1, brandfiMarcaId]);

  const [api, contextHolder] = notification.useNotification();

  const openNotificationWithIcon = (type, message, description = "") => {
    api[type]({
      message: message,
      description: description,
    });
  };

  // const { post, loading, success } = usePost();

  const { request, loading, success, resetRequestValues } = useRequest();

  const { values, handleChange, resetForm, setInitialValues } = useForm({
    marcaId: 0,
    emails: [],
  });

  useEffect(() => {
    if (isEdit) {
      setInitialValues({
        marcaId: selectedItem.FIMARCAID,
        emails: selectedItem.FCLISTAREMITENTES.split(","),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItem, isEdit]);

  const isDisabled = () => {
    return values.marcaId === 0 || values.emails.length === 0 || loading;
  };

  const handleSubmit = async () => {
    const data = {
      FIMARCAID: values.marcaId,
      FCLISTAREMITENTES: values.emails.join(","),
      FITIPOREPORTEID: 1 /* 1: Ingresos Faltantes */,
      FIPAISID: 1,
    };

    await request({
      endPoint: "faltante/remitente",
      method: "post",
      data,
    });
  };

  const handleSubmitEdit = async () => {
    const data = {
      FIMARCAID: values.marcaId,
      FCLISTAREMITENTES: values.emails.join(","),
      FITIPOREPORTEID: 1 /* 1: Ingresos Faltantes */,
      FIPAISID: 1,
    };

    await request({
      endPoint: "faltante/remitente",
      method: "put",
      data,
    });
  };
  useEffect(() => {
    if (success) {
      openNotificationWithIcon("success", ` ${isEdit ? "Editado" : "Agregado"} correctamente.`);
      resetForm();
      setShowModal(false);
      setIsEdit(false);
      refetch();
      resetRequestValues();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success]);

  useEffect(() => {
    if (!isEdit) {
      if (isBranchAlreadyCreated(values.marcaId)) {
        openNotificationWithIcon("warning", "La marca ya tiene remitentes agregados.");
        setShowModal(false);
        setIsEdit(false);
        resetForm();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.marcaId, isEdit]);

  return (
    <>
      {contextHolder}
      <Modal
        open={showModal}
        onCancel={() => {
          setShowModal(false);
          setIsEdit(false);
          resetForm();
        }}
        footer={null}
      >
        <Row justify="space-around">
          <Col span={24}>
            <div className="input-content-titulo">{isEdit ? "Editar" : "Agregar"} remitentes</div>
          </Col>

          <Form
            name="AddRemitente"
            labelCol={{
              span: 8,
            }}
            wrapperCol={{
              span: 16,
            }}
            style={{
              maxWidth: 600,
            }}
            initialValues={{
              remember: true,
            }}
            autoComplete="off"
          >
            <label className="text-context-inputs">Marca:</label>
            <Select
              style={{ width: "100%" }}
              onChange={(value) => {
                handleChange("marcaId", value);
              }}
              value={values.marcaId}
              disabled={isEdit}
            >
              <Select.Option value={0} disabled={true}>
                Seleccionar
              </Select.Option>
              {marcas.map((marca) => (
                <Select.Option key={marca.value} value={marca.value}>
                  {marca.label}
                </Select.Option>
              ))}
            </Select>
            <div className="text-context-inputs pt-4">Email(s):</div>
            <TagsInput values={values} handleChange={handleChange} />

            <Button
              type="primary"
              htmlType="submit"
              disabled={isDisabled()}
              className="button-styles-add-element"
              onClick={isEdit ? handleSubmitEdit : handleSubmit}
              style={{ marginTop: 20 }}
              loading={loading}
            >
              {
                // eslint-disable-next-line no-nested-ternary
                loading ? "Cargando..." : isEdit ? "Editar" : "Agregar"
              }
            </Button>
          </Form>
        </Row>
      </Modal>
    </>
  );
}
